// removed by extract-text-webpack-plugin
module.exports = {"root":"_1VH_U","first":"zuyXG"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Events/pages/Show/Organizations/style.sass
// module id = ./src/modules/Events/pages/Show/Organizations/style.sass
// module chunks = 6